﻿import { WrapperGS } from "@ivanlog/gs";
import { BiMath } from "./BiMath";

export class Web3Helper
{
    public static ShortLabel(wr:WrapperGS, value:bigint|undefined=undefined, round:number=3, symbol="")
    {
        if (!value)
        {
            wr.text="-";
            wr.onclick=undefined;
            return;
        }
        let post = "";
        if (symbol) post=" "+symbol;
        wr.text = BiMath.TruncEth(BiMath.ToEth(value),round)+post;
        wr.onclick = () => wr.text = BiMath.ToEth(value)+post;
    }  
    public static ToLargeNumberUnit(value:bigint, round:number=3, symbol=""):string
    {
        if (!value) return "-";
        let post = "";
        if (symbol) post=" "+symbol;
        const eth = BiMath.ToEth(value);
        let dec = parseFloat(eth);
        if (dec<1)
        {
            const shortValue = BiMath.TruncEth(eth,round);
            if (parseFloat(shortValue)===0 && dec>0)
                return `0.${"0".repeat(round)}..`+post;
            return shortValue+post;
        }
        let acc = dec;
        let exp=0;
        while(acc>=1000)
        {
            acc=acc/1000;
            exp++;
        }
        return Math.trunc(acc*10)/10+Web3Helper.GetLargeNumberUnit(exp)+post;
    }

    public static GetLargeNumberUnit(exp=0)
    {
        switch(exp)
        {
            case 0: return "";
            case 1: return "k";
            case 2: return "M";
            case 3: return "B";
            case 4: return "T";
            case 5: return "Qa";
            case 6: return "Qi";
            case 7: return "Sx";
            case 8: return "Sp";
            case 9: return "Oc";
            case 10: return "No";
            default: return "-";
        }
    }
}
